<ds-button
  [attr.variation]="buttonVariation()"
  [attr.class-name]="additionalClasses()"
  [attr.disabled]="disabled() ? true : null"
  (ds-click)="handleClick()"
  analytics="true">
  <ng-content />
</ds-button>
